import { render, staticRenderFns } from "./BreakdownChart.vue?vue&type=template&id=0a034f23&scoped=true"
import script from "./BreakdownChart.vue?vue&type=script&lang=js"
export * from "./BreakdownChart.vue?vue&type=script&lang=js"
import style0 from "./BreakdownChart.vue?vue&type=style&index=0&id=0a034f23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a034f23",
  null
  
)

export default component.exports